<template>
  <base-card>
    <h2>We will help you find your coach!</h2>
    <span class="filter-option">
      <input type="checkbox" id="frontend" checked @change="changeFilter" />
      <label for="frontend">Frontend</label>
    </span>
    <span class="filter-option">
      <input type="checkbox" id="backend" checked v-on:change="changeFilter" />
      <label for="backend">Backend</label>
    </span>
    <span class="filter-option">
      <input type="checkbox" id="career" checked v-on:change="changeFilter" />
      <label for="career">Career</label>
    </span>
  </base-card>
</template>
<script>
export default {
    emits:['change-filter'],
  data() {
    return {
      filters: {
        frontend: true,
        backend: true,
        career: true,
      },
    };
  },
  methods: {
    changeFilter(evt) {
      let inputId = evt.target.id;
      let isActive = evt.target.checked;
      const updatedFilter = {
        ...this.filters,
        [inputId]: isActive,
      };
      this.filters = updatedFilter;
      this.$emit('change-filter',updatedFilter);
    },
  },
};
</script>

<style scoped>
</style>